// extracted by mini-css-extract-plugin
export default {"wrapper":"defaults_wrapper__Uk97m","content":"defaults_content__e3TEK"};